import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_63: FaireProductEntity = {
  token: "starter_collection_63",
  type: "product",
  name: "Sardine Cocktail Napkins",
  brandName: "Piecework",
  imageUrl: "",
  priceDollars: 28,
  msrpDollars: 56,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
